import { render } from "./FollowUpChips.vue?vue&type=template&id=dc7c5598&scoped=true"
import script from "./FollowUpChips.vue?vue&type=script&lang=js"
export * from "./FollowUpChips.vue?vue&type=script&lang=js"

import "./FollowUpChips.vue?vue&type=style&index=0&id=dc7c5598&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc7c5598"]])

export default __exports__